// @ts-nocheck
import Upload from "@store/Library/Components/Toolkit/Icons/Upload";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import { IconWrapper } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import { formInputStyles } from "@store/Themes/common/mixins/form";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";
/* Store Custom Code - End */

const fileUpload: Styleguide["fileUpload"] = {
    defaultProps: {
        /* Store Custom Code - Start */
        buttonProps: {
            variant: "secondary",
            css: css`
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: ${pxToRem(45)};
                line-height: ${pxToRem(40)};
            `,
        },
        cssOverrides: {
            inputSelect: css`
                ${formInputStyles()}

                &:hover,
                    &:focus {
                    ${IconWrapper} {
                        color: ${getColor("secondary")};
                    }
                }
            `,
            formInputWrapper: css`
                &:hover,
                &:focus {
                    ${IconWrapper} {
                        color: ${getColor("secondary")};
                    }
                }
            `,
            appearanceTransition: css`
                &&& button {
                    margin-top: 0;

                    &:hover,
                    &:focus {
                        ${IconWrapper} {
                            color: ${getColor("secondary")};
                        }
                    }
                }
            `,
        },
        /* Store Custom Code - End */
    },
};

export default fileUpload;
